<template>
    <div id="company">
        <div class="company-info-wrap">
            <div class="company">
                <p>
                    상호 : (주)디벨로퍼그룹 <br>
                    대표이사 : 이승호 <br>
                    사업자등록번호 : 843-86-01190 <br>
                    <a :href="'tel:'+company_info.service_number" class="phone"><span><strong>TEL.&nbsp;&nbsp;</strong>1811-8684</span></a>
                    <a><span><strong>FAX.&nbsp;&nbsp;</strong>070-8668-0555</span></a><br>
                    주소 : 대전광역시 동구 백룡로 76 (용운동), 디벨로퍼그룹
                </p>
                <!-- <p>
                    대표이사 : {{company_info.ceo}} <br>
                    사업자등록번호 : {{company_info.company_number}} <br>
                    <a :href="'tel:'+company_info.service_number" class="phone"><span><strong>TEL.&nbsp;&nbsp;</strong>{{company_info.service_number}}</span></a>
                    <a :href="'tel:'+company_info.service_number"><span><strong>FAX.&nbsp;&nbsp;</strong>{{company_info.service_number}}</span></a><br>
                    주소 : {{company_info.address}}
                </p> -->
            </div>
        </div>
    </div>
</template>

<script>
    import * as config from './../../js/config';
    import common from './../../js/common';
    export default {
        name: "company",
        data(){
            return {    
                company_info: {}
            }
        },
        mounted(){
            this.$nextTick(function(){
                common.getData(config.REQ_COMPANY_INFO,{},
                    (result) => {
                        this.company_info = result[0];
                    }
                )
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/component/CompanyInfoComponent.vue